module.exports = __webpack_public_path__ + "img/Direct Impact on Conservation.9e1244bc.png";